

$(document).ready(function(){
	$('.lookbook_slick').slick({
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  autoplay: false,
	  autoplaySpeed: 2000,
	  dots: false,
	  centerMode: false,
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.call_video').click(function(){
	$('.video_popup').slideDown(200);
	$('body, html').css('overflow','hidden');
  $('#myVideo')[0].play();

});
$('.close_it').click(function(){
	$('.video_popup').slideUp(200);
	$('body, html').css('overflow-y','scroll');
	$('#myVideo')[0].pause();
});

});